export const UPDATE_PRODUCT_LIST = "update_prod_list";
export const ADD_PRODUCT_TO_CART = "add_prod_to_cart";
export const TOGGLE_CART_VISIBILITY = "toggle_cart_visibility";
export const TOGGLE_SEARCH_WINDOW_VISIBILITY = "toggle_search_visibility";
export const UPDATE_STYLE_ON_VIEW = "update_style_on_view";
export const UPDATE_SIZE_ON_VIEW = "update_size_on_view";
export const UPDATE_AMOUNT_CARTITEM = "update_amount_cart_item";